import React from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
toast.configure();

const KonfirmasiStepDua = ({
  konfirmasiModalOpen,
  toggleRealokasiModal,
  nextStep,
  formRealokasi,
}) => {
  const isTarget = formRealokasi.is_target === "t";
  return (
    <Modal isOpen={konfirmasiModalOpen} toggle={() => toggleRealokasiModal()}>
      <ModalHeader>Konfirmasi Realokasi</ModalHeader>
      <ModalBody>
        {`Apakah anda yakin ${
          isTarget ? "mengurangi" : "menambahkan"
        } dana untuk Anggaran yang dipilih ini dan ${
          !isTarget ? "mengurangi dari" : "menambahkan ke"
        } Anggaran yang akan dipilih nantinya?`}
      </ModalBody>

      <ModalFooter>
        <Button
          color="danger"
          type="button"
          onClick={() => toggleRealokasiModal()}
        >
          Tidak
        </Button>
        <Button
          color="primary"
          type="button"
          onClick={() => toggleRealokasiModal() & nextStep()}
        >
          Iya
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default KonfirmasiStepDua;
